import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import ExportHelper from '../chart_helpers/ExportHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { dentedRect } from '../utils/pathUtils'
import { scaleBand as d3_scaleBand } from 'd3-scale'
import { select as d3_select } from 'd3-selection'

const MAX_BAR_WIDTH = 40
const MAX_CANDY_DIAMETER = 14

export default class LollipopBarChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * Orientation of the bars. When setting `horizontal: true` the x and y axes will be swapped.
     */
    horizontal: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    colorMode: {
      type: String,
      default: 'normal',
      options: ['normal', 'tritanopia'],
    },
    mode: {
      type: String,
      default: 'single',
      options: ['single', 'grouped', 'stacked'],
    },
    /**
     * Minimum height of each bar (in pixels).
     */
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    AxisHelper: {
      /**
       * Enable automatic scroll. If enabled, axes will be scrolalbel only if the number of bars is large enough.
       */
      zoom: {
        value: false,
      },
      x: {
        scale: {
          value: 'band',
          exposed: false,
        },
        getExtent: function(data) {
          if (this.config.mode === 'stacked') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else if (this.config.mode === 'grouped') return categoricalExtent(data)
          //return data[0].value.map((d)=>d.id)
          else return categoricalExtent(data) //return data.map((d)=>d.id)
        },
      },
      y: {
        side: 'right',
        getExtent: function(data) {
          let extent, extentParts
          if (this.config.mode === 'stacked') {
            extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          } else if (this.config.mode === 'grouped') {
            extentParts = continuousExtentParts(data)
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts) //d3.extent(data.reduce((res,d)=>res.concat(d3.extent(d.value,(dd)=>dd.value)),[]))
          } else {
            extentParts = data.reduce((a, d) => {
              a.push({ value: [d, d] })
              d.lollipop.forEach(l => a.push({ value: [l, l] }))
              return a
            }, [])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(
              data.reduce((acum, datum) => {
                return acum.concat([datum, ...datum.lollipop])
              }, [])
            ) //d3.extent(data,(d)=>d.value)
          }

          //Protect label!
          // let originalExtent = extent

          // extent = padLinear(extent,0.2)

          // NOT GOOD, porque se hace el padlinear luego, en el _setDomain
          // if(originalExtent[0]>=0) extent[0]=0
          // console.log("bar extent bef",extent)
          extent = cleanCollisions(this.axes.y, extent, extentParts)
          // console.log("bar extent aft",extent)
          return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top - 5,
        }
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, AxisHelper, ExportHelper]
  checkConsistency() {
    return true
  }
  draw() {
    let longDir, getTranslate, getOffset, getShort //,shortDir

    longDir = 'width'
    // shortDir = 'height'
    getTranslate = (long, short) => {
      return `translate(${long},${short})`
    }

    let offsetValue
    if (this.axes.y.func.scale().domain()[0] < 0 && this.axes.y.func.scale().domain()[1] > 0)
      offsetValue = 0
    else offsetValue = this.axes.y.func.scale().domain()[0]

    getOffset = v => Math.min(v, this.axes.y.func.scale()(offsetValue))
    getShort = v => Math.abs(this.axes.y.func.scale()(offsetValue) - v)

    let barPercent = 0.7
    let barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
    let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2

    let drawItem
    drawItem = (sel, status) => {
      sel.attr('transform', d => {
        let barPos
        if (status === 'enter' || status === 'exit') barPos = getOffset(this.axes.y.func.scale()(0))
        else barPos = getOffset(this.axes.y.func.scale()(d.safeValue))
        return getTranslate(this.axes.x.func.scale()(d.id) + barMargin, barPos)
      })
      sel
        .select('path')
        .attr('fill', d => this.color(d))
        .attr('d', d => {
          let barLength
          if (status === 'enter' || status === 'exit') barLength = 0
          else barLength = getShort(this.axes.y.func.scale()(d.safeValue))
          let w = longDir === 'width' ? barWidth : barLength
          let h = longDir === 'width' ? barLength : barWidth
          let dent = 0 //longDir==='width'?(d.safeValue>0?['tl','br']:'bl'):(d.safeValue>0?['bl','tr']:'tr')

          let gap = null
          if (
            this.axes.y.func.scale().isChunky &&
            d.safeValue > this.axes.y.func.scale()._threshold
          ) {
            gap =
              this.axes.y.func.scale()(this.axes.y.func.scale()._threshold) -
              this.axes.y.func.scale()(d.safeValue)
          }
          return dentedRect(w, h, dent, gap)
        })

      this.drawLollipops(sel.select('.lollipop'), status)
    }

    this.itemsEnter.append('path')
    const enterLollipop = this.itemsEnter.append('g').attr('class', 'lollipop')
    enterLollipop
      .selectAll('.stick')
      .data([null])
      .enter()
      .append('rect')
      .attr('class', 'stick')

    // Se ha de hacer el data binding de los candies con todos
    // los items. Existing items pueden ver modificada sus candies
    // y si solo hacemos el binding en el enter no se actualizan
    const candyData = this.items.data().concat(this.itemsEnter.data())
    const candies = this.items
      .merge(this.itemsEnter)
      .selectAll('.lollipop')
      .selectAll('.candy')
      .data(d => candyData.find(dd => dd.id === d.id)?.lollipop || [])
      .join(
        enter => {
          enter.append('polygon').attr('class', 'candy')
        },
        update => {},
        exit => exit.remove()
      )

    // Hay que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
    this.itemsEnter.call(drawItem, 'enter')
    this.itemsTrans.call(drawItem) // .on('end', this.drawLollipops(this))
    this.itemsEnterTrans.call(drawItem)
    this.itemsExitTrans.style('opacity', 0)
    if (this.parentItemsExitTrans) this.parentItemsExitTrans.style('opacity', 0)
  }

  drawLollipops(sel, status) {
    const self = this
    let offsetValue
    if (self.axes.y.func.scale().domain()[0] < 0 && self.axes.y.func.scale().domain()[1] > 0) {
      offsetValue = 0
    } else offsetValue = self.axes.y.func.scale().domain()[0]
    const getOffset = v => Math.min(v, self.axes.y.func.scale()(offsetValue))

    const barPercent = 0.7
    const barWidth = Math.min(MAX_BAR_WIDTH, self.axes.x.scale.bandwidth() * barPercent)
    const barMargin = (self.axes.x.scale.bandwidth() - barWidth) / 2

    if (status === 'enter') {
      sel
        .select('.stick')
        .attr('fill', this.config.colorMode == 'normal' ? '#7C4DFF' : '#bbb')
        .attr('stroke', '#fff')
        .attr('width', 3)
        .attr('x', barWidth / 2 - 1.5)
        .attr('y', 0)
        .attr('height', 0)
        .attr('opacity', 0)

      sel
        .selectAll('.candy')
        .attr('fill', this.config.colorMode == 'normal' ? '#7C4DFF' : '#bbb')
        .attr('stroke', '#fff')
        .attr('stroke-width', '1px')
        .style('transform', `translate(${barWidth / 2}px, 0px`)
    } else {
      sel
        .select('.stick')
        .attr('fill', this.config.colorMode == 'normal' ? '#7C4DFF' : '#bbb')
        .style('display', d => (d.lollipop.length > 0 ? 'block' : 'none'))
        .attr('y', d => Math.min(...d.lollipop.map(d => getCandyPosition(d)), 0))
        .attr('x', barWidth / 2 - 1.5)
        .attr('height', d => {
          return (
            Math.max(...d.lollipop.map(d => getCandyPosition(d)), 0) -
            Math.min(...d.lollipop.map(d => getCandyPosition(d)), 0)
          )
        })
        .attr('opacity', 1)

      sel
        .selectAll('.candy')
        .attr('fill', this.config.colorMode == 'normal' ? '#7C4DFF' : '#bbb')
        .attr('points', (d, i) =>
          self.candyPolygonPoints(i, Math.min(MAX_CANDY_DIAMETER, barWidth / 2))
        )
        .style('transform', (d, i) => {
          return `translate(${barWidth / 2}px, ${getCandyPosition(d)}px)`
        })
        .style('display', d => (d.value === null ? 'none' : 'block'))
    }

    function getCandyPosition(d) {
      if (!d.value) return 0
      const barOffset = getOffset(self.axes.y.func.scale()(d.parent))
      const candyOffset = getOffset(self.axes.y.func.scale()(d.value))
      return candyOffset - barOffset
    }
  }

  candyPolygonPoints(i, w) {
    let rad
    let circumference = Math.PI * 2
    switch (i) {
      case 0:
        rad = circumference / 16
        return Array.apply(null, Array(16))
          .map((d, i) => `${Math.sin(rad * i) * w * 0.5}, ${Math.cos(rad * i) * w * 0.5}`)
          .join(' ')
        break
      case 1:
        rad = circumference / 4
        return Array.apply(null, Array(4))
          .map(
            (d, i) =>
              `${Math.sin(rad * (i + 0.5)) * w * 0.5}, ${Math.cos(rad * (i + 0.5)) * w * 0.5}`
          )
          .join(' ')
        break
      case 2:
        rad = circumference / 3
        return Array.apply(null, Array(3))
          .map((d, i) => `${Math.sin(rad * i) * w * 0.5}, ${Math.cos(rad * i) * w * 0.5}`)
          .join(' ')
        break
      case 3:
        rad = circumference / 3
        return Array.apply(null, Array(3))
          .map(
            (d, i) =>
              `${Math.sin(rad * i + Math.PI) * w * 0.5}, ${Math.cos(rad * i + Math.PI) * w * 0.5}`
          )
          .join(' ')
        /* rad = circumference / 4
          const rect = Array.apply(null, Array(4))
            .map((d, i) => `${Math.sin(rad * i) * w * 0.5}, ${Math.cos(rad * i) * w * 0.5}`)
            .join(' ')
          return rect
            .split(' ')
            .map(d => d + ' 0, 0')
            .join(' ') */

        break
      case 4:
        rad = circumference / 4
        return Array.apply(null, Array(4))
          .map((d, i) => `${Math.sin(rad * i) * w * 0.5}, ${Math.cos(rad * i) * w * 0.5}`)
          .join(' ')
        break
      default:
        rad = circumference / 4
        return Array.apply(null, Array(4))
          .map(
            (d, i) =>
              `${Math.sin(rad * (i + 0.5)) * w * 0.5}, ${Math.cos(rad * (i + 0.5)) * w * 0.5}`
          )
          .join(' ')
        break
    }
  }
}
